import React, { useMemo, useState } from 'react';
import { formatDateTime } from '../utils/time';

const ContactTimeline = ({ events, members, onAddContact, prefillMemberId }) => {
  const [draft, setDraft] = useState({
    memberId: '',
    type: 'note',
    summary: ''
  });
  const [saving, setSaving] = useState(false);

  const memberOptions = useMemo(
    () =>
      members.map((member) => ({
        label: member.name,
        value: member._id
      })),
    [members]
  );

  const memberById = useMemo(() => {
    const map = new Map();
    members.forEach((member) => map.set(member._id, member));
    return map;
  }, [members]);

  React.useEffect(() => {
    if (prefillMemberId) {
      setDraft((prev) => ({ ...prev, memberId: prefillMemberId }));
    }
  }, [prefillMemberId]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!draft.memberId || !draft.summary) return;
    setSaving(true);
    await onAddContact({
      memberId: draft.memberId,
      type: draft.type,
      summary: draft.summary,
      direction: 'manual',
      childId: memberById.get(draft.memberId)?.childId,
      at: new Date().toISOString()
    });
    setDraft({ memberId: '', type: 'note', summary: '' });
    setSaving(false);
  };

  return (
    <div className="contact-timeline">
      <header>
        <h2>Contact Timeline</h2>
      </header>
      <form className="contact-timeline__form" onSubmit={handleSubmit}>
        <select name="memberId" value={draft.memberId} onChange={handleChange}>
          <option value="">Select member</option>
          {memberOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <select name="type" value={draft.type} onChange={handleChange}>
          <option value="note">Note</option>
          <option value="phone">Phone</option>
          <option value="text">Text</option>
          <option value="email">Email</option>
          <option value="meeting">Meeting</option>
        </select>
        <input
          type="text"
          name="summary"
          placeholder="Log contact or next step"
          value={draft.summary}
          onChange={handleChange}
        />
        <button type="submit" className="primary" disabled={saving}>
          {saving ? 'Logging…' : 'Add'}
        </button>
      </form>
      <ul className="contact-timeline__list">
        {events.map((event) => {
          const member = memberById.get(event.memberId);
          return (
            <li key={event._id}>
              <div className="contact-timeline__timestamp">{formatDateTime(event.at)}</div>
              <div className="contact-timeline__detail">
                <strong>{member?.name ?? 'Unknown'}</strong>
                <span className="chip chip--muted">{event.type}</span>
                <p>{event.summary}</p>
                <small>Recorded by {event.createdBy}</small>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ContactTimeline;
